import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Loader2, ShieldCheck } from "lucide-react";
import Logo from "@/components/Logo";
import { useAuth } from "@/context/AuthContext";
import { apiError } from "@/lib/api";
import { toast } from "sonner";

export default function AdminLogin() {
  const { adminLogin } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault(); setLoading(true); setErr("");
    try { await adminLogin(form.email, form.password); toast.success("Welcome, admin"); nav("/admin"); }
    catch (e2) { const m = apiError(e2); setErr(m); toast.error(m); }
    setLoading(false);
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#0B0C0E] grid-glow p-4">
      <div className="absolute top-1/3 left-1/2 -translate-x-1/2 h-80 w-80 rounded-full bg-amber-500/10 blur-[120px]" />
      <div className="relative w-full max-w-md">
        <div className="flex justify-center mb-6"><Logo size="lg" to="/" /></div>
        <div className="card-lux p-8">
          <div className="flex items-center gap-2 mb-1"><ShieldCheck className="text-amber-400" size={20} /><h1 className="text-xl font-bold text-white">Admin Panel</h1></div>
          <p className="text-sm text-slate-400 mb-6">Secure administrator access only.</p>
          <form onSubmit={submit} className="space-y-4" data-testid="admin-login-form">
            {err && <div className="rounded-lg bg-red-500/10 border border-red-500/30 text-red-300 text-sm px-4 py-3" data-testid="admin-login-error">{err}</div>}
            <div><label className="label-lux">Email</label><input required type="email" className="input-lux mt-2" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} data-testid="admin-email-input" /></div>
            <div><label className="label-lux">Password</label><input required type="password" className="input-lux mt-2" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} data-testid="admin-password-input" /></div>
            <button disabled={loading} className="gold-btn w-full" data-testid="admin-login-btn">{loading ? <Loader2 className="animate-spin" size={18} /> : "Sign In"}</button>
          </form>
        </div>
      </div>
    </div>
  );
}
